import { render, staticRenderFns } from "./FrameDataModal.vue?vue&type=template&id=c5873aa6&scoped=true"
import script from "./FrameDataModal.vue?vue&type=script&lang=js"
export * from "./FrameDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5873aa6",
  null
  
)

export default component.exports